import React, { memo } from 'react'

const ProfileAvatar = ({ src = null, className = '', initials = '' }) => {
  return (
    <div className="avatar_container">
      {src ? (
        <img className={`avatar ${className}`} src={src} alt="Profile Avatar" />
      ) : (
        <span
          className="no_avatar"
          style={{
            backgroundColor: 'rgb(0, 168, 149)',
          }}
        >
          {initials}
        </span>
      )}
    </div>
  )
}

export default memo(ProfileAvatar)
